import Accordion from "react-bootstrap/Accordion";
import { Container, Row, Col } from "reactstrap";

import plus from "../../../../assets/images/+.png";

import "./index.scss";

const FAQSection = () => {
  return (
    <section id="faq" className="faq-section">
      <Container data-aos="fade-up" className="black-card">
        <img className="plus" src={plus} alt="plus" />
        <Row>
          <Col sm="12" md="12" lg="12">
            <h3 className="title">
              FREQUENTLY <br /> ASKED
              <br /> QUESTIONS
            </h3>
          </Col>
          <Col sm="12" md="12" lg="12">
            <Accordion>
              <Row className="d-flex justify-content-center">
                <Col sm="12" md="5" lg="5">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      Who can apply for Career Plus?
                    </Accordion.Header>
                    <Accordion.Body>
                      3rd, 4th-grade students, new graduates and master students
                      from reputable universities with a related Bachelor’s
                      degree; young talents who have an intermediate or higher
                      level of English, have decided on the sector they want to
                      work in and planned their career journey, have
                      participated in activities that will make a difference in
                      their resume, and aim to demonstrate their competencies by
                      expressing themselves easily can apply to Career Plus.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Is English required to join Career Plus?
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes, candidates with an intermediate or higher level as a
                      result of the English assessment can participate.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      How will our English level be determined?
                    </Accordion.Header>
                    <Accordion.Body>
                      English level will be determined after the online exam
                      which will be solved during the evaluation process.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      Is it possible to apply from any university?
                    </Accordion.Header>
                    <Accordion.Body>
                      No, only the universities in the list can apply. However,
                      candidates from universities outside the list can be
                      included in the evaluation process by sending their CVs
                      to&nbsp;
                      <a href="mailto:apply@careerplus.org">
                        apply@careerplus.org
                      </a>
                      .
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      Will I pay a fee to attend the camp?
                    </Accordion.Header>
                    <Accordion.Body>
                      A symbolic fee is charged to ensure candidates'
                      participation in the camp.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      Who evaluates the applications made through Career Plus?
                    </Accordion.Header>
                    <Accordion.Body>
                      Your applications will be reviewed by our professional
                      Human Resources team.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      What is the process after applying?
                    </Accordion.Header>
                    <Accordion.Body>
                      You can find detailed information in the "Process" tab on
                      the main page.
                    </Accordion.Body>
                  </Accordion.Item>
                </Col>
                <Col sm="12" md="5" lg="5">
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      Can I change or delete the applications I have made?
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes, you can make changes or delete them by contacting our
                      team via the e-mail address in our contact information.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="8">
                    <Accordion.Header>
                      Where can I follow my applications and their answers?
                    </Accordion.Header>
                    <Accordion.Body>
                      After your applications are reviewed, positive/negative
                      feedback will be sent to you via e-mail or telephone.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="9">
                    <Accordion.Header>
                      My university/department is not included in the
                      application form. What should I do?
                    </Accordion.Header>
                    <Accordion.Body>
                      You can send the information requested in the application
                      form and your CV to &nbsp;
                      <a href="mailto:apply@careerplus.org">
                        apply@careerplus.org
                      </a>
                      .
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="10">
                    <Accordion.Header>
                      Can I apply to more than one camp?
                    </Accordion.Header>
                    <Accordion.Body>
                      Unfortunately, you can only take part in one sector's
                      camp.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="11">
                    <Accordion.Header>
                      Do I have to attend all sessions and activities?
                    </Accordion.Header>
                    <Accordion.Body>
                      Participation in all sessions, case studies and activities
                      in the camp process is mandatory.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="12">
                    <Accordion.Header>
                      I have another question; how can I reach you?
                    </Accordion.Header>
                    <Accordion.Body>
                      You can send us your questions from the Contact tab.
                    </Accordion.Body>
                  </Accordion.Item>
                </Col>
              </Row>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQSection;
